import React from 'react';
import { ChevronDown } from 'lucide-react';
import { ARTIST_AGE_FILTER_OPTIONS } from '../utils/artistAge';

export const SALON_FILTER_SELECT_CLASS =
  'salon-explore-select w-full appearance-none rounded-xl border border-[#F5D99B] bg-white/[0.92] py-2 pl-3 pr-9 text-sm font-semibold text-[#2F251B] shadow-sm transition-colors focus:border-[#F59E0B] focus:outline-none focus:ring-2 focus:ring-[#F59E0B]/25';

/**
 * Age-range filter as a compact dropdown (All ages · 6–8 · 9–11 · 12+).
 */
export default function ArtistAgeFilterSelect({
  value,
  onChange,
  className = '',
  id = 'salon-age-select',
  label = 'Artist age',
  hideLabel = false,
}) {
  const ageFilter = value ?? 'all';
  const setAgeFilter = onChange ?? (() => {});

  return (
    <div className={`min-w-0 ${className}`}>
      {!hideLabel ? (
        <label
          htmlFor={id}
          className="mb-1 block text-[10px] font-semibold uppercase tracking-[0.12em] text-[#8A6A44]"
        >
          {label}
        </label>
      ) : null}
      <div className="relative">
        <select
          id={id}
          value={ageFilter}
          onChange={(e) => setAgeFilter(e.target.value)}
          className={SALON_FILTER_SELECT_CLASS}
          aria-label="Filter by artist age"
        >
          {ARTIST_AGE_FILTER_OPTIONS.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown
          className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#8A6A44]"
          strokeWidth={2}
          aria-hidden
        />
      </div>
    </div>
  );
}
